import React from 'react'
import { Typography } from '@mui/material'

interface DashboardsSubtitleProps {
    expanded: boolean
}

export const DashboardsSubtitle: React.VFC<DashboardsSubtitleProps> = ({ expanded }: DashboardsSubtitleProps) => {
    return (
        <Typography
            sx={{
                visibility: expanded ? 'visible' : 'hidden',
                marginTop: '15px',
                marginLeft: 3.3,
                marginBottom: 1,
                fontWeight: 600,
            }}
            variant="caption"
        >
            DASHBOARDS
        </Typography>
    )
}

export default DashboardsSubtitle
